import { useGetUserInfo } from 'containers/pages/Messaging/CampaignDialog/WizardContextV3/useGetUserInfo';
import { useGetInfo } from 'hooks';
import { IEnablementInfoV3 } from 'interface/WizardV3';

interface IUserInfo {
  firstName: string;
  lastName: string;
  email: string;
  nextivaUUID: string;
}
export function useGetUserInfoAvatar(enablementInfo: IEnablementInfoV3) {
  const {
    data: userInfoCurrentAccount,
    isLoading: isLoadingInfoCurrentAccount,
  } = useGetInfo();
  const {
    userInfo: userInfoRequester,
    isLoading: isLoadingUserInfoRequester,
  } = useGetUserInfo(enablementInfo?.requesterUuid);
  const userInfo: IUserInfo = {
    firstName:
      userInfoRequester?.firstName || userInfoCurrentAccount?.firstName || '',
    lastName:
      userInfoRequester?.lastName || userInfoCurrentAccount?.lastName || '',
    email: userInfoRequester?.email || userInfoCurrentAccount?.email || '',
    nextivaUUID:
      userInfoRequester?.nextivaUUID ||
      userInfoCurrentAccount?.nextivaUUID ||
      '',
  };
  const isNotLoading =
    !isLoadingUserInfoRequester || !isLoadingInfoCurrentAccount;

  return { userInfo, isNotLoading };
}
